<template>
  <EmailComponentsPtAccountList />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
